<template>
  <v-dialog v-model="showVideo" persistent max-width="800">
    <v-card>
      <div class="text-xs-right">
        <v-btn
          flat
          fab
          dark
          small
          color="grey"
          style="line-height: 10px"
          @click="$emit('input', false)"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <v-layout row wrap>
          <v-flex class="mb-2" xs6>
            <h3>Issue ID</h3>
            <div>{{ data.id }}</div>
          </v-flex>
          <v-flex class="mb-2" xs6>
            <h3>Date</h3>
            <div>{{ data.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</div>
          </v-flex>
          <v-flex class="mb-2" xs12>
            <h3>Topic</h3>
            <div>{{ data.topic }}</div>
          </v-flex>
          <v-flex class="mb-2" xs12>
            <h3>ชื่อผุ้แจ้ง</h3>
            <div>{{ data.social_name }}</div>
          </v-flex>
          <v-flex class="mb-2" xs6>
            <h3>Position</h3>
            <div>{{ data.position }}</div>
          </v-flex>
          <v-flex class="mb-2" xs6>
            <h3>Dept.</h3>
            <div>{{ data.department }}</div>
          </v-flex>
          <v-flex class="mb-2" xs12>
            <h3>Detail</h3>
            <div>{{ data.detail }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center align-content-center>
          <v-btn outline color="grey" @click="$emit('input', false)">{{ $t('Close') }}</v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: ['value', 'data'],
  data: function () {
    return {
      showVideo: this.value
    }
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/reporting/issueReport/ModalReport.vue